import { AdminService } from '../admin/AdminService';
import { AnalyticsService } from '../analytics/AnalyticsService';
import { ApiType } from '../ApiType';
import { ChainalysisService } from '../chainalysis/ChainalysisService';
import { MetadataService } from '../metadata/MetadataService';
import { PlotsService } from '../plots/PlotsService';
import { UserService } from '../user/UserService';

export interface Suite {
  readonly apiType?: ApiType,
  
  readonly userService: UserService,
  readonly adminService: AdminService,
  readonly metadataService: MetadataService,
  readonly plotsService: PlotsService,
  readonly analyticsService: AnalyticsService,
  readonly chainalysisService: ChainalysisService,

  mainSuite?: Suite
}

const suites: {
  [key in ApiType]?: Suite
} = {};

let mainSuite: Suite;

export function registerSuite(suite: Suite): void {
  if (!suite.apiType) {
    throw new Error('Missing apiType while registering suite');
  }
  if (suites[suite.apiType]) {
    throw new Error(`Suite type "${suite.apiType}" already registered`);
  }
  suites[suite.apiType] = suite;
  if (mainSuite) { suite.mainSuite = mainSuite; }
}

export function getSuite(apiType: ApiType): Suite {
  if (!suites[apiType]) {
    throw new Error(`No suite registered with type "${apiType}"`);
  }
  return suites[apiType];
}

export function setMainSuite(suite: Suite): void {
  mainSuite = suite;
  for (const s of Object.values(suites)) {
    s.mainSuite = mainSuite;
  }
}

export function getMainSuite(): Suite {
  return mainSuite;
}
